var router = new VueRouter({
  mode: "history", //to set it to html5mode, other value can be 'hash' for hashband method
  base: window.owConfig.apiBase, //this is needed in html5mode to calculate relative url
  routes: [
    /*{
            name: 'home',
            path: '/home',
            alias: '/',
            component(resolve) {
                owLazyRoute('home-page', resolve);
            }
        },*/
    {
      name: "error",
      path: "/error",
      component(resolve) {
        owLazyRoute("error-page", resolve);
      }
    },
    {
      name: "login",
      path: "/login",
      alias: "/",
      component(resolve) {
        owLazyRoute("login-page", resolve);
      }
    },
    {
      name: "amount-pay",
      path: "/amount-pay",
      component(resolve) {
        owLazyRoute("amount-pay", resolve);
      }
    },
    {
      name: "accept-pp-pay",
      path: "/accept-pp-pay",
      component(resolve) {
        owLazyRoute("accept-pp-pay", resolve);
      }
    },
    {
      name: "upi-wait",
      path: "/upiwait",
      props: true,
      component(resolve) {
        owLazyRoute("upi-wait-page", resolve);
      }
    },
    {
      name: "payment-page",
      path: "/payment-page",
      component(resolve) {
        owLazyRoute("payment-page", resolve);
      }
    },
    {
      name: "payment-options",
      path: "/payment-options",
      props: true,
      component(resolve) {
        owLazyRoute("payment-options", resolve);
      }
    },
    {
      name: "payment-status",
      path: "/payment-status",
      props: true,
      component(resolve) {
        owLazyRoute("payment-status", resolve);
      }
    },
    {
      name: "clear-pp",
      path: "/clear-pp",
      props: true,
      component(resolve) {
        owLazyRoute("clear-pp", resolve);
      }
    },
    {
      name: "acceptcredit",
      path: "/acceptcredit",
      component(resolve) {
        owLazyRoute("credit-accept", resolve);
      }
    },
    {
      name: "update-app",
      path: "/update-app",
      props: true,
      component(resolve) {
        owLazyRoute("update-app", resolve);
      }
    },
    {
      name: "receipt-80g-details",
      path: "/receipt-80g-details",
      component(resolve) {
        owLazyRoute("receipt-80g-details", resolve);
      }
    },
    {
      name: "ola-foundation-donation",
      path: "/ola-foundation-donation",
      component(resolve) {
        owLazyRoute("ola-foundation-donation", resolve);
      }
    },
    {
      name: "postpaid",
      path: "/postpaid",
      component(resolve) {
        owLazyRoute("postpaid-debit", resolve);
      }
    },
    {
      name: "info",
      path: "/info",
      component(resolve) {
        owLazyRoute("info-page", resolve);
      }
    },
    {
      name: "min-kyc-otp",
      path: "/min-kyc-otp",
      props: true,
      component(resolve) {
        owLazyRoute("min-kyc-otp", resolve);
      }
    },
    {
      name: "user-details",
      path: "/user-details",
      props: true,
      component(resolve) {
        owLazyRoute("user-details", resolve);
      }
    },
    {
      name: "status-page",
      path: "/status-page",
      props: true,
      component(resolve) {
        owLazyRoute("status-page", resolve);
      }
    },
    {
      name: "sms-tnc",
      path: "/sms-tnc",
      props: true,
      component(resolve) {
        owLazyRoute("sms-tnc-page", resolve);
      }
    },
    {
      name: "transaction-otp",
      path: "/transaction-otp",
      component(resolve) {
        owLazyRoute("transaction-otp", resolve);
      }
    },
    {
      name: "raise-concern",
      path: "/raise-concern",
      component(resolve) {
        owLazyRoute("raise-concern", resolve);
      }
    },

    // insurance start
    {
      name: "insurance",
      path: "/insurance",
      component(resolve) {
        owLazyRoute("insurance-page", resolve);
      }
    },
    {
      name: "insurance-status",
      path: "/insurance-status",
      component(resolve) {
        owLazyRoute("insurance-status", resolve);
      }
    },
    {
      name: "insurance-user-details",
      path: "/details",
      component(resolve) {
        owLazyRoute("insurance-user-details", resolve);
      }
    },
    {
      name: "verify",
      path: "/verify",
      component(resolve) {
        owLazyRoute("insurance-verify-otp", resolve);
      }
    },
    // insurance ends

    //RSA starts
    {
      name: "rsa",
      path: "/rsa/:id",
      component(resolve) {
        owLazyRoute("rsa-home", resolve);
      },
      props: true
    },
    //RSA ends

    //Credit Card starts
    {
      name: "cc-onboard-steps",
      path: "/cc-onboard/:id",
      component(resolve) {
        owLazyRoute("cc-onboard", resolve);
      }
    },
    {
      name: "cc-account",
      path: "/cc-account",
      component(resolve) {
        owLazyRoute("cc-account", resolve);
      }
    },
    {
      name: "cc-nps",
      path: "/cc-nps",
      component(resolve) {
        owLazyRoute("cc-nps", resolve);
      }
    },
    {
      name: "cc-account-summary-faq",
      path: "/cc-account-summary-faq",
      component(resolve) {
        owLazyRoute("cc-account-summary-faq", resolve);
      }
    },
    {
      name: "cc-account-summary-faq-item",
      path: "/cc-account-summary-faq/:id",
      component(resolve) {
        owLazyRoute("cc-faq-page", resolve);
      },
      props: true
    },
    {
      name: "cc-account-referral",
      path: "/cc-account-referral",
      component(resolve) {
        owLazyRoute("cc-account-referral", resolve);
      }
    },
    {
      name: "cc-statement-analyser",
      path: "/cc-statement-analyser",
      component(resolve) {
        owLazyRoute("cc-statement-analyser", resolve);
      },
      props: true
    },
    {
      name: "cc-bill-history",
      path: "/cc-bill-history",
      component(resolve) {
        owLazyRoute("cc-bill-history", resolve);
      },
      props: true
    },
    {
      name: "cc-empty-state",
      path: "/cc-empty-state",
      component(resolve) {
        owLazyRoute("cc-empty-state", resolve);
      },
      props: true
    },
    {
      name: "cc-transaction-history",
      path: "/cc-transaction-history",
      component(resolve) {
        owLazyRoute("cc-transaction-history", resolve);
      }
    },
    {
      name: "cc-track-status",
      path: "/cc-track-status",
      component(resolve) {
        owLazyRoute("cc-track-status", resolve);
      }
    },
    {
      name: "cc-offer-dynamic",
      path: "/cc-offer-dynamic",
      component(resolve) {
        owLazyRoute("cc-offer-dynamic", resolve);
      }
    },
    {
      name: "cc-offer-page",
      path: "/cc-offer-page/:id",
      component(resolve) {
        owLazyRoute("cc-offer-page", resolve);
      }
    },
    {
      name: "cc-csq-main",
      path: "/cc-csq",
      component(resolve) {
        owLazyRoute("cc-csq", resolve);
      }
    },
    {
      name: "cc-csq-steps",
      path: "/cc-csq/:id",
      component(resolve) {
        owLazyRoute("cc-csq", resolve);
      }
    },
    {
      name: "cc-csq-form-page",
      path: "/cc-csq-form-page",
      component(resolve) {
        owLazyRoute("cc-csq-form-page", resolve);
      }
    },
    {
      name: "cc-account-breakup",
      path: "/cc-account-breakup",
      component(resolve) {
        owLazyRoute("cc-account-breakup", resolve);
      }
    },
    {
      name: "cc-offers-list-page",
      path: "/cc-offers-list-page",
      component(resolve) {
        owLazyRoute("cc-offers-list-page", resolve);
      }
    },
    {
      name: "cc-txn-details-page",
      path: "/cc-txn-details-page",
      component(resolve) {
        owLazyRoute("cc-txn-details-page", resolve);
      }
    },
    {
      name: "cc-express-interest-landing",
      path: "/cc-express-interest-landing",
      component(resolve) {
        owLazyRoute("cc-express-interest-pitch", resolve);
      }
    },
    {
      name: "cc-express-interest-form",
      path: "/cc-express-interest/form",
      component(resolve) {
        owLazyRoute("cc-express-interest", resolve);
      }
    },
    {
      name: "cc-express-interest-tnc",
      path: "/cc-express-interest/tnc",
      component(resolve) {
        owLazyRoute("cc-express-interest-tnc", resolve);
      }
    },
    {
      name: "cc-billdesk-payment-init",
      path: "/cc-billdesk-payment-init",
      component(resolve) {
        owLazyRoute("cc-billdesk-payment-init", resolve);
      }
    }
    //Credit Card ends
  ]
});

router.beforeEach(function(to, from, next) {
  try {
    //to change BG color of certain pages before entering route
    const creditAppEle = document.getElementById("credit-app"),
      blackBgEleList = [
        /cc-offer-page\/*/,
        /cc-express-interest$/,
        /cc-onboard\/onboarding/
      ];
    let matchedFlag = false;
    blackBgEleList.forEach(function(item) {
      if (
        item.test(to.path) &&
        (!to.query.referrer ||
          (to.query.referrer && to.query.referrer !== "dashboard"))
      ) {
        matchedFlag = true;
        creditAppEle.classList.add("black-bg");
      }
    });
    if (!matchedFlag) {
      creditAppEle.classList.remove("black-bg");
    }

    //to scroll page to TOP
    creditAppEle.scrollTo(0, 0);
  } catch (e) {
   // Raven.captureException(e.message);
  }
  next();
});

window.router = router;
